import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

import type { CanvasQaResult } from "./types";

export const isCanvasQaResult = objectOf<CanvasQaResult>({
  status: number,
  agent_results: maybe(
    arrayOf(
      objectOf({
        agent_id: string,
        qa_results: maybe(
          arrayOf(
            objectOf({
              rule: string,
              status: string,
              reason: string,
              ruleset_name: maybe(string),
              basis: maybe(string),
              // Canvas identifier fields. The backend stamps these via
              // QaAgentDefinition#identifier_extra_fields; step_id/step_name are
              // present only on message-step-scope results.
              scope: maybe(string),
              step_id: maybe(string),
              step_name: maybe(string),
              // Id of the AgentInvocationLog that produced the result; echoed
              // back on resolutions so the audit mirror can address the log.
              invocation_log_id: maybe(string),
              // Set when this rule's ruleset prompt was truncated, so the results show a warning.
              prompt_truncated: maybe(boolean),
            })
          )
        ),
        execution_time_ms: maybe(number),
        error_code: maybe(string),
        error_message: maybe(string, true),
      })
    )
  ),
  execution_time_ms: maybe(number),
  error_code: maybe(string),
  chunked_result_complete: maybe(boolean),
  run_request_id: maybe(string),
});
